import React from 'react';
import { FormattedMessage } from 'react-intl';
import configs from 'config';
import PropTypes from 'prop-types';
import { isInnerPage } from 'shared/utils/isInnerPage';
import LanguageSelector from 'modules/language/components/LanguageSelector';
import { Icon, MaterialHint } from 'shared/components';

import Info from './Info';
import TermsAndConditionsLink from '../TermsAndConditionsLink';
import theme from './Footer.scss';
import AccessibilityPopover from '../AccessibilityPopover';


const propTypes = {
  intl: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

const Footer = ({
  location,
  intl,
  anchorEl,
  openPopover,
  closePopover,
  setAccessibilityEnabled,
  isAuthorized,
}) => (
  <footer className={ theme.root }>
    <div className={ theme.accessibilityButtonWrap }>
      <MaterialHint
        placement="right"
        title={ intl.formatMessage({ id: 'AccessibilityButton.Tooltip', defaultMessage: '** Open accessibility options' }) }
      >
        <button
          id="open-accessibility-options-button"
          className={ theme.accessibilityButton }
          data-testid="accessibility-popover-open-button"
          onClick={ openPopover }
          aria-label={ intl.formatMessage({ id: 'AccessibilityButton.Tooltip', defaultMessage: '** Open accessibility options' }) }
        >
          <Icon name="wheel-chair" />
        </button>

      </MaterialHint>
    </div>
    <AccessibilityPopover setAccessibilityEnabled={ setAccessibilityEnabled } closePopover={ closePopover } popoverOpened={ !!anchorEl } />
    <div className={ theme.text }>
      <FormattedMessage
        id="General.Footer.Copyright"
        defaultMessage="** Company Footer"
      />
      &nbsp; Ver. { configs.release_version } { configs.build_number }
      <Info />
      <TermsAndConditionsLink />
    </div>

    { isInnerPage(location.pathname) && isAuthorized ? (
      <div className={ theme.langs }>
        <LanguageSelector size="xsmall" withMenuOverlay={ true } />
      </div>
    ) : (
      <div />
    ) }
  </footer>
);

Footer.propTypes = propTypes;

export default Footer;
